const MANUAL_COMPARISON_COLORS = [
  "#d97706",
  "#7c5bd6",
  "#0891b2",
  "#db2777",
  "#65a30d",
  "#dc2626",
];

export function manualComparisonColor(instrumentId) {
  const value = String(instrumentId || "");
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash * 31) + value.charCodeAt(index)) >>> 0;
  }
  return MANUAL_COMPARISON_COLORS[hash % MANUAL_COMPARISON_COLORS.length];
}

export function chunkInstrumentIds(instrumentIds, size = 3) {
  const chunks = [];
  for (let index = 0; index < instrumentIds.length; index += size) {
    chunks.push(instrumentIds.slice(index, index + size));
  }
  return chunks;
}

export function filterManualComparisonCandidates(items, {
  currentInstrumentId,
  currentCode,
  selected = [],
  excludedInstrumentIds = [],
  excludedCodes = [],
} = {}) {
  const excludedIds = new Set([
    currentInstrumentId,
    ...excludedInstrumentIds,
    ...selected.map((item) => item.instrument_id),
  ].filter(Boolean));
  const excludedCodeSet = new Set([
    currentCode,
    ...excludedCodes,
    ...selected.map((item) => item.code),
  ].filter(Boolean).map((code) => String(code).toUpperCase()));

  return (items || []).filter((item) => (
    !excludedIds.has(item.instrument_id)
    && !excludedCodeSet.has(String(item.code || "").toUpperCase())
  ));
}

export function mergeMarketSeriesPayloads(payloads) {
  const seriesById = new Map();
  for (const payload of payloads) {
    for (const series of payload?.data?.series || []) {
      seriesById.set(series.instrument_id, series);
    }
  }
  return { data: { series: [...seriesById.values()] } };
}
